import { render } from "./PatientLinePasscode.vue?vue&type=template&id=1a0c5a9d"
import script from "./PatientLinePasscode.vue?vue&type=script&lang=js"
export * from "./PatientLinePasscode.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__